export default __webpack_public_path__ + "static/media/sex-female.1fe76a27.svg";